import { render, staticRenderFns } from "./QuoteRefrence.vue?vue&type=template&id=149d9072"
import script from "./QuoteRefrence.vue?vue&type=script&lang=js"
export * from "./QuoteRefrence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports